import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { userProfile } from 'redux/saga/entities/bound';
import { decorateWith, withName } from 'helpers/decorator';
import { deepExtract } from 'helpers/deep';
import { FriendbuyWidget } from './FriendbuyWidget';

export const mapStateToProps = (state, { widgetCode }) => {
  const profile = userProfile.data(state) || {};

  return {
    userId: profile.id,
    countryCode: deepExtract('msa.country_code', profile, 'USA'),
    email: profile.email,
    widgetCode: widgetCode || deepExtract('friendbuy_info.widget_code', profile, ''),
  };
};

export const FriendbuyWidgetContainer = decorateWith(
  connect(mapStateToProps),
  injectIntl,
  withName('FriendbuyWidgetContainer')
)(FriendbuyWidget);
